module.exports = __webpack_public_path__ + "static/01_corezoid-visa-privatbank-teams-5dc7646da9b814e50a5dbaef3b682a83.jpg";